import type { RouteLocationNormalized } from 'vue-router'

/**
 * You can use this to exit early in middleware when it doesn't need to be run
 * when only the query params have changed.
 */
export function isSamePage(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
) {
  // When paths are equal but fullPaths are not, it means that
  // we are navigating to the same page but with different query params.
  // Only checking if the paths are the same is not enough, because they are
  // always the same on initial load.
  return to.path === from.path && to.fullPath !== from.fullPath
}
